import React from 'react';
import './panels.css';

function HelpPanel() {
  return (
    <div className="panel">
      <h2>Help &amp; Support</h2>
      <p className="panel-intro">A quick guide to what's where on the platform.</p>

      <h3>Home</h3>
      <p className="panel-intro">An overview of what's on the platform and a description of the UCAT ANZ exam.</p>

      <h3>UCAT Excellence Program</h3>
      <p className="panel-intro">
        A structured 30-week course, split into weekly sections in the sidebar. Available to students enrolled in the
        Excellence Program tier.
      </p>

      <h3>Self-Guided Study</h3>
      <p className="panel-intro">
        Reference material for each of the four UCAT sections, plus general exam tips — available to everyone.
      </p>

      <h3>Practice Exams</h3>
      <p className="panel-intro">
        Mini Mock (shorter) and Full Mock (real exam length) papers, timed section-by-section to the official UCAT
        ANZ format. Each paper shows a breakdown of sections, question counts, and time limits before you start.
      </p>

      <h3>Question Bank</h3>
      <p className="panel-intro">
        Browse and answer individual questions by section and topic. Each question shows a difficulty rating; use
        "See Answer"/"Explain Answer" to check the correct answer and read the full explanation.
      </p>

      <h3>My Results</h3>
      <p className="panel-intro">
        Every past practice session and exam you've completed, with personalised feedback showing which topics to
        focus on next.
      </p>

      <div className="help-contact">
        <h3>Need more help?</h3>
        <p>
          Email <a href="mailto:thestudium@hotmail.com">thestudium@hotmail.com</a> for any questions about the
          program or using this platform.
        </p>
      </div>
    </div>
  );
}

export default HelpPanel;
